import { RefObject, useEffect, useState } from "react";

export const useElementVisible = (sentinelRef: RefObject<HTMLDivElement>) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            }, {
                threshold: 1,
            });

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            if (sentinelRef.current) {
                observer.unobserve(sentinelRef.current);
            }
        };
    }, [sentinelRef]);

    return isVisible;
};
